module.exports = __webpack_public_path__ + "static/split-view-909487ee6588fb502b7384bb0e07b6c7.mp4";